const decodeHtml = (orgin) => {
    return orgin
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        ;
}

export default decodeHtml;